module.exports = __webpack_public_path__ + "static/assets/ddcb37c1e48c6a37cb44f47ca46f1a83.svg";